import HttpFactory from "~/repository/factory";
import type {
  FavoriteCreateResponse,
  FavoriteListResponse,
} from "~/types/teacher/profile/favorites";
import { ENDPOINTS } from "~/repository/endpoints";

class TeacherProfileFavoritesModule extends HttpFactory {
  async getFavorites(): Promise<FavoriteListResponse[]> {
    return await this.get(`${ENDPOINTS.PROFILE.MY_FAVORITES}`);
  }

  async postFavorite(lessonId: string): Promise<FavoriteCreateResponse> {
    return await this.post(`${ENDPOINTS.PROFILE.MY_FAVORITES}`, {
      lesson: lessonId,
    });
  }

  async deleteFavorite(lessonId: string) {
    return await this.delete(`${ENDPOINTS.PROFILE.MY_FAVORITES}${lessonId}`);
  }
}

export { TeacherProfileFavoritesModule };
